export default __webpack_public_path__ + "static/media/logo-jeongukminju-color.10ea6c91.png";